/** Tabs available on the member profile page; first entry is the default. */
export const PROFILE_TABS = ['about', 'posts', 'comments', 'following', 'followers'] as const;
export type ProfileTab = (typeof PROFILE_TABS)[number];

/** id used by `aria-controls` on tab buttons and `id` on the tab body container. */
export const PROFILE_PANEL_ID = 'member-profile-panel';

const isProfileTab = (value: string): value is ProfileTab => PROFILE_TABS.some((tab) => tab === value);

export const parseProfileTab = (raw: string | null): ProfileTab => {
  if (raw !== null && isProfileTab(raw)) return raw;

  return 'about';
};
